import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import Users from './pages/users/Users';
import Dashboard from './pages/dashboards/Dashboard';
import UserProfile from './pages/profiles/UserProfile';
import LayoutWrapper from './components/LayoutWrapper';
import CreateUser from './pages/users/CreateUser';
import UserDetail from './pages/users/UserDetail';
import Notifications from './pages/Notifications';
import Supervisors from './pages/supervisor/Supervisors';
import SupervisorDetail from './pages/supervisor/SupervisorDetail';
import SupervisorMap from './pages/supervisor/SupervisorMap';
import CreateSupervisor from './pages/supervisor/CreateSupervisor';
import SupervisorQuotas from './pages/supervisor/SupervisorQuotas';
import SupervisorAddressesMap from './pages/supervisor/SupervisorAddressesMap';
import StaffAddressesMap from './pages/quota/StaffAddressesMap';
import SupervisorQuotaDetail from './pages/supervisor/SupervisorQuotaDetail';
import Controllers from './pages/controller/Controllers';
import CreateController from './pages/controller/CreateController';
import ControllerDetail from './pages/controller/ControllerDetail';
import ArchiveControllers from './pages/controller/ArchiveControllers';
import Interviewers from './pages/interviewer/Interviewers';
import CreateInterviewer from './pages/interviewer/CreateInterviewer';
import ArchiveInterviewers from './pages/interviewer/ArchiveInterviewers';
import InterviewerDetail from './pages/interviewer/InterviewerDetail';
import InterviewerVerification from './pages/interviewer/InterviewerVerification';
import PaymentBatches from './pages/paiements/PaymentBatches';
import CreatePaymentBatch from './pages/paiements/CreatePaymentBatch';
import PaymentBatchDetail from './pages/paiements/PaymentBatchDetail';
import PaymentVerification from './pages/paiements/PaymentVerification';
import PaymentConfirmation from './pages/paiements/PaymentConfirmation';
import PaymentLineDetail from './pages/paiements/PaymentLineDetail';
import PaymentHistory from './pages/paiements/PaymentHistory';
import PaymentAudit from './pages/paiements/PaymentAudit';
import UnpaidPayments from './pages/paiements/UnpaidPayments';
import ArchivePaymentBatches from './pages/paiements/ArchivePaymentBatches';
import SectionReviewDashboard from './pages/paiements/SectionReviewDashboard';

import AuditUsers from './pages/audit/AuditUsers';
import ArchiveUsers from './pages/users/ArchiveUsers';
import ArchiveSupervisors from './pages/supervisor/ArchiveSupervisors';
import ChargeEtudes from './pages/users/chargeEtudes/ChargeEtudes';
import CreateChargeEtude from './pages/users/chargeEtudes/CreateChargeEtude';
import ChargeEtudeDetail from './pages/users/chargeEtudes/ChargeEtudeDetail';
import ChefTerrains from './pages/users/chefTerrain/ChefTerrains';
import Formations from './pages/formations/Formations';
import CreateFormation from './pages/formations/CreateFormation';
import FormationDetail from './pages/formations/FormationDetail';
import ViewFormation from './pages/formations/ViewFormation';
import EditFormation from './pages/formations/EditFormation';
import AssignFormation from './pages/formations/AssignFormation';
import PresenceChecklist from './pages/formations/PresenceChecklist';
import MyFormations from './pages/formations/MyFormations';
import CreateChefTerrain from './pages/users/chefTerrain/CreateChefTerrain';
import ChefTerrainDetail from './pages/users/chefTerrain/ChefTerrainDetail';
import Responsables from './pages/users/responsables/Responsables';
import CreateResponsable from './pages/users/responsables/CreateResponsable';
import CatiPosts from './pages/cati/CatiPosts';
import CreateCatiPost from './pages/cati/CreateCatiPost';
import EditCatiPost from './pages/cati/EditCatiPost';
import CatiAssignments from './pages/cati/CatiAssignments';
import CreateCatiAssignment from './pages/cati/CreateCatiAssignment';
import CreateCatiInterviewer from './pages/cati/CreateCatiInterviewer';
import CatiInterviewers from './pages/cati/CatiInterviewers';
import CatiInterviewerDetail from './pages/cati/CatiInterviewerDetail';
import CatiInterviewerAudit from './pages/cati/CatiInterviewerAudit';
import InterviewerPayments from './pages/cati/InterviewerPayments';
import ControllerMyPayments from './pages/controle/ControllerMyPayments';
import CreateSurvey from './pages/cati/CreateSurvey';
import SurveyDetail from './pages/cati/SurveyDetail';
import SurveyStats from './pages/cati/SurveyStats';
import CatiSurveys from './pages/cati/CatiSurveys';
import InterviewUploads from './pages/cati/InterviewUploads';
import InterviewUploadDetail from './pages/cati/InterviewUploadDetail';
import InterviewLineDetail from './pages/cati/InterviewLineDetail';
import UploadInterviewFile from './pages/cati/UploadInterviewFile';
import CatiProductivity from './pages/cati/CatiProductivity';
import F2FProductivity from './pages/f2f/F2FProductivity';
import SupervisorPayments from './pages/f2f/SupervisorPayments';
import PrestatairePayments from './pages/f2f/PrestatairePayments';
import SupervisorFraisDeplacement from './pages/f2f/SupervisorFraisDeplacement';
import FraisDeplacementList from './pages/f2f/FraisDeplacementList';
import FraisDeplacementBuilder from './pages/f2f/FraisDeplacementBuilder';
import ProcessInterviewLines from './pages/cati/ProcessInterviewLines';
import CatiRendezVous from './pages/cati/CatiRendezVous';
import CatiRendezVousLine from './pages/cati/CatiRendezVousLine';
import CatiAgencyBlacklist from './pages/cati/CatiAgencyBlacklist';
import CatiAnomalies from './pages/cati/CatiAnomalies';
import SurveySelection from './pages/control/SurveySelection';
import FullControlSurveys from './pages/control/FullControlSurveys';
import FullControlSubmissions from './pages/control/FullControlSubmissions';
import F2fNewSubmissions from './pages/control/F2fNewSubmissions';
import AlertsList from './pages/control/AlertsList';
import QualityBatchesList from './pages/control/QualityBatchesList';
import CompletedControls from './pages/control/CompletedControls';
import ControlStats from './pages/control/ControlStats';
import F2fPaymentPreview from './pages/control/F2fPaymentPreview';
import ControllerStats from './pages/control/ControllerStats';
import ProductivityStats from './pages/cati/ProductivityStats';
import ControlWorkspace from './pages/control/ControlWorkspace';
import ControlOnDemandSearch from './pages/control/ControlOnDemandSearch';
import ControlOnHold from './pages/control/ControlOnHold';
import ControlOnHoldDetail from './pages/control/ControlOnHoldDetail';
import MyChecks from './pages/control/MyChecks';
import RespControleWorkspace from './pages/control/RespControleWorkspace';
import RespControleMyChecks from './pages/control/RespControleMyChecks';
import RespControleOnHold from './pages/control/RespControleOnHold';
import RespControleOnHoldDetail from './pages/control/RespControleOnHoldDetail';
import RespControleAiUpload from './pages/control/RespControleAiUpload';
import RespControleAiChecks from './pages/control/RespControleAiChecks';
import ControllerAttendance from './pages/control/ControllerAttendance';
import InterviewerAttendance from './pages/cati/InterviewerAttendance';
import SupervisorsCatiList from './pages/supervisors_cati/SupervisorsCatiList';
import CreateSupervisorCati from './pages/supervisors_cati/CreateSupervisorCati';
import EditSupervisorCati from './pages/supervisors_cati/EditSupervisorCati';
import QuotaProjects from './pages/quota/QuotaProjects';
import QuotaBuilder from './pages/quota/QuotaBuilder';
import CreateQuotaProject from './pages/quota/CreateQuotaProject';
import ProjectKanban from './pages/projects/ProjectKanban';
import ProjectCreate from './pages/projects/ProjectCreate';
import ProjectDetail from './pages/projects/ProjectDetail';
import ProjectArchive from './pages/projects/ProjectArchive';
import ClosingKanban from './pages/projects/ClosingKanban';
import SlotDetail from './pages/projects/SlotDetail';
import SlotEdit from './pages/projects/SlotEdit';
import BudgetReview from './pages/projects/BudgetReview';
import BudgetEdit from './pages/projects/BudgetEdit';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route 
              path="/users" 
              element={
                <ProtectedRoute allowedRoles={['administrateur_general', 'administrateur_general_superieur', 'admin_it']}>
                  <LayoutWrapper>
                    <Users />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/users/create" 
              element={
                <ProtectedRoute allowedRoles={['administrateur_general', 'administrateur_general_superieur', 'admin_it']}>
                  <LayoutWrapper>
                    <CreateUser />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/users/:id" 
              element={
                <ProtectedRoute allowedRoles={['administrateur_general', 'administrateur_general_superieur', 'admin_it', 'chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <UserDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/audit" 
              element={
                <ProtectedRoute allowedRoles={['administrateur_general', 'administrateur_general_superieur', 'admin_it', 'chef_terrain', 'chef_terrain_superieur', 'resp_controle', 'charge_etude_superieur']}>
                  <LayoutWrapper>
                    <AuditUsers />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <LayoutWrapper>
                    <Dashboard />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  <LayoutWrapper>
                    <Notifications />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin', 'resp_controle']}>
                  <LayoutWrapper>
                    <ProjectKanban />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/create"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin', 'resp_controle']}>
                  <LayoutWrapper>
                    <ProjectCreate />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/archive"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin', 'resp_controle']}>
                  <LayoutWrapper>
                    <ProjectArchive />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/closing"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin', 'resp_controle']}>
                  <LayoutWrapper>
                    <ClosingKanban />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin', 'resp_controle']}>
                  <LayoutWrapper>
                    <ProjectDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id/slots/:slotId"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin', 'resp_controle']}>
                  <LayoutWrapper>
                    <SlotDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id/slots/:slotId/edit"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin', 'resp_controle']}>
                  <LayoutWrapper>
                    <SlotEdit />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id/budgets/create"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin', 'resp_controle']}>
                  <LayoutWrapper>
                    <BudgetEdit />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id/budgets/:budgetId/edit"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin', 'resp_controle']}>
                  <LayoutWrapper>
                    <BudgetEdit />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id/budgets/:budgetId/review"
              element={
                <ProtectedRoute allowedRoles={['administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <BudgetReview />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile" 
              element={
                <ProtectedRoute>
                  <LayoutWrapper>
                    <UserProfile />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            {/* Supervisor Management Routes */}
            <Route 
              path="/supervisors"
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'admin_it', 'administrateur_general', 'administrateur_general_superieur', 'charge_etude', 'charge_etude_superieur', 'resp_controle']}>
                  <LayoutWrapper>
                    <Supervisors />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/supervisors/create" 
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'admin_it']}>
                  <LayoutWrapper>
                    <CreateSupervisor />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/supervisors/:id"
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'admin_it', 'administrateur_general', 'administrateur_general_superieur', 'charge_etude', 'charge_etude_superieur', 'resp_controle']}>
                  <LayoutWrapper>
                    <SupervisorDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/supervisors-archived" 
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'admin_it']}>
                  <LayoutWrapper>
                    <ArchiveSupervisors />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/supervisors-map"
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'admin_it', 'administrateur_general', 'administrateur_general_superieur', 'charge_etude', 'charge_etude_superieur']}>
                  <LayoutWrapper>
                    <SupervisorMap />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            {/* Supervisor Quotas Routes (Supervisors only) */}
            <Route 
              path="/supervisor/my-quotas" 
              element={
                <ProtectedRoute allowedRoles={['superviseur']}>
                  <LayoutWrapper>
                    <SupervisorQuotas />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/supervisor/my-quotas/:id"
              element={
                <ProtectedRoute allowedRoles={['superviseur']}>
                  <LayoutWrapper>
                    <SupervisorQuotaDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/supervisor/addresses-map"
              element={
                <ProtectedRoute allowedRoles={['superviseur']}>
                  <LayoutWrapper>
                    <SupervisorAddressesMap />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/quotas/addresses-map"
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'admin_it']}>
                  <LayoutWrapper>
                    <StaffAddressesMap />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            {/* Controller Management Routes */}
            <Route 
              path="/controllers" 
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'admin_it', 'charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <Controllers />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/controllers/create" 
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'admin_it']}>
                  <LayoutWrapper>
                    <CreateController />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/controllers/:id" 
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'admin_it', 'charge_etude', 'charge_etude_superieur', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin']}>
                  <LayoutWrapper>
                    <ControllerDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/controllers/archived" 
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'admin_it']}>
                  <LayoutWrapper>
                    <ArchiveControllers />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            {/* Interviewer Management Routes */}
            <Route 
              path="/interviewers"
              element={
                <ProtectedRoute allowedRoles={['superviseur', 'admin_it', 'chef_terrain', 'chef_terrain_superieur', 'resp_controle']}>
                  <LayoutWrapper>
                    <Interviewers />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/interviewers/create" 
              element={
                <ProtectedRoute allowedRoles={['superviseur', 'admin_it', 'chef_terrain', 'chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <CreateInterviewer />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/interviewers/archived" 
              element={
                <ProtectedRoute allowedRoles={['superviseur', 'admin_it', 'chef_terrain', 'chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <ArchiveInterviewers />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/interviewers/:id"
              element={
                <ProtectedRoute allowedRoles={['superviseur', 'admin_it', 'chef_terrain', 'chef_terrain_superieur', 'resp_admin', 'administrateur_general', 'administrateur_general_superieur', 'charge_etude', 'charge_etude_superieur', 'resp_controle']}>
                  <LayoutWrapper>
                    <InterviewerDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/interviewers/verification" 
              element={
                <ProtectedRoute allowedRoles={['resp_admin']}>
                  <LayoutWrapper>
                    <InterviewerVerification />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            {/* Payment Routes (Resp Admin and Chef Terrain Superieur) */}
            <Route 
              path="/payments" 
              element={
                <ProtectedRoute allowedRoles={['resp_admin', 'chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <PaymentBatches />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/payments/create" 
              element={
                <ProtectedRoute allowedRoles={['resp_admin', 'chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <CreatePaymentBatch />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/payments/archived"
              element={
                <ProtectedRoute allowedRoles={['resp_admin', 'chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <ArchivePaymentBatches />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/payments/sections"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'chef_terrain', 'resp_controle', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <SectionReviewDashboard />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/payments/:id"
              element={
                <ProtectedRoute allowedRoles={[]}>
                  <LayoutWrapper>
                    <PaymentBatchDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/payments/:id/lines/:lineId"
              element={
                <ProtectedRoute allowedRoles={[]}>
                  <LayoutWrapper>
                    <PaymentLineDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/payments/verification" 
              element={
                <ProtectedRoute allowedRoles={['administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <PaymentVerification />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/payments/history" 
              element={
                <ProtectedRoute allowedRoles={['administrateur_general', 'administrateur_general_superieur', 'resp_cati', 'chef_terrain', 'resp_controle']}>
                  <LayoutWrapper>
                    <PaymentHistory />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/payments/audit" 
              element={
                <ProtectedRoute allowedRoles={['administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <PaymentAudit />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/payments/:id/confirm" 
              element={
                <ProtectedRoute allowedRoles={['resp_admin']}>
                  <LayoutWrapper>
                    <PaymentConfirmation />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/payments/unpaid" 
              element={
                <ProtectedRoute allowedRoles={['resp_admin', 'administrateur_general', 'administrateur_general_superieur', 'chef_terrain_superieur', 'resp_cati', 'chef_terrain', 'resp_controle']}>
                  <LayoutWrapper>
                    <UnpaidPayments />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/users/archived" 
              element={
                <ProtectedRoute allowedRoles={['administrateur_general', 'administrateur_general_superieur', 'admin_it', 'charge_etude_superieur', 'chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <ArchiveUsers />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/charge-etudes" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude_superieur']}>
                  <LayoutWrapper>
                    <ChargeEtudes />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/charge-etudes/create" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude_superieur']}>
                  <LayoutWrapper>
                    <CreateChargeEtude />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/charge-etudes/:id" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude_superieur']}>
                  <LayoutWrapper>
                    <ChargeEtudeDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            
            {/* Formation Routes - Charge d'Étude */}
            <Route 
              path="/formations" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'administrateur_general', 'administrateur_general_superieur', 'chef_terrain', 'chef_terrain_superieur', 'resp_controle', 'resp_cati']}>
                  <LayoutWrapper>
                    <Formations />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/formations/create" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'administrateur_general', 'administrateur_general_superieur', 'chef_terrain', 'chef_terrain_superieur', 'resp_controle', 'resp_cati']}>
                  <LayoutWrapper>
                    <CreateFormation />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/formations/:id" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'administrateur_general', 'administrateur_general_superieur', 'chef_terrain', 'chef_terrain_superieur', 'resp_controle', 'resp_cati']}>
                  <LayoutWrapper>
                    <FormationDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/formations/:id/edit" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'administrateur_general', 'administrateur_general_superieur', 'chef_terrain', 'chef_terrain_superieur', 'resp_controle', 'resp_cati']}>
                  <LayoutWrapper>
                    <EditFormation />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/formations/:id/assign" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'administrateur_general', 'administrateur_general_superieur', 'chef_terrain', 'chef_terrain_superieur', 'resp_controle', 'resp_cati']}>
                  <LayoutWrapper>
                    <AssignFormation />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/formations/:id/presence" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'administrateur_general', 'administrateur_general_superieur', 'chef_terrain', 'chef_terrain_superieur', 'resp_controle', 'resp_cati']}>
                  <LayoutWrapper>
                    <PresenceChecklist />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            
            {/* Formation Routes - Beneficiaries (Interviewers, Controllers, Supervisors) */}
            <Route 
              path="/my-formations" 
              element={
                <ProtectedRoute allowedRoles={['enqueteur', 'controleur', 'superviseur']}>
                  <LayoutWrapper>
                    <MyFormations />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/formations/:id/view" 
              element={
                <ProtectedRoute allowedRoles={['enqueteur', 'enqueteur_cati', 'controleur', 'superviseur']}>
                  <LayoutWrapper>
                    <ViewFormation />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            
            {/* Responsables Routes (chef_terrain_superieur) */}
            <Route 
              path="/responsables" 
              element={
                <ProtectedRoute allowedRoles={['chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <Responsables />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/responsables/create" 
              element={
                <ProtectedRoute allowedRoles={['chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <CreateResponsable />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/responsables/archived" 
              element={
                <ProtectedRoute allowedRoles={['chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <ArchiveUsers />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            
            {/* Keep old chef-terrains routes for backward compatibility */}
            <Route 
              path="/chef-terrains" 
              element={
                <ProtectedRoute allowedRoles={['chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <Responsables />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/chef-terrains/create" 
              element={
                <ProtectedRoute allowedRoles={['chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <CreateResponsable />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/chef-terrains/:id" 
              element={
                <ProtectedRoute allowedRoles={['chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <ChefTerrainDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            
            {/* CATI Routes */}
            <Route 
              path="/cati/posts" 
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <CatiPosts />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/posts/create" 
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <CreateCatiPost />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/posts/:id/edit" 
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <EditCatiPost />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/assignments" 
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <CatiAssignments />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/assignments/create" 
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <CreateCatiAssignment />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/interviewer/create" 
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <CreateCatiInterviewer />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/interviewers/:id"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'charge_etude', 'charge_etude_superieur', 'resp_controle', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_admin']}>
                  <LayoutWrapper>
                    <CatiInterviewerDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/interviewers"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'charge_etude', 'charge_etude_superieur', 'resp_controle', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <CatiInterviewers />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/interviewers/audit"
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <CatiInterviewerAudit />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/my-payments" 
              element={
                <ProtectedRoute allowedRoles={['enqueteur']}>
                  <LayoutWrapper>
                    <InterviewerPayments />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/f2f/my-payments"
              element={
                <ProtectedRoute allowedRoles={['superviseur']}>
                  <LayoutWrapper>
                    <SupervisorPayments />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/payments/prestataires"
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <PrestatairePayments />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/supervisor/frais-deplacement"
              element={
                <ProtectedRoute allowedRoles={['superviseur']}>
                  <LayoutWrapper>
                    <SupervisorFraisDeplacement />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cati/interviewer/interviews"
              element={
                <ProtectedRoute allowedRoles={['enqueteur']}>
                  <LayoutWrapper>
                    <ProcessInterviewLines />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/interviewer/rendez-vous" 
              element={
                <ProtectedRoute allowedRoles={['enqueteur']}>
                  <LayoutWrapper>
                    <CatiRendezVous />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/interviewer/rendez-vous/:lineId" 
              element={
                <ProtectedRoute allowedRoles={['enqueteur']}>
                  <LayoutWrapper>
                    <CatiRendezVousLine />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/controle/my-payments" 
              element={
                <ProtectedRoute allowedRoles={['controleur']}>
                  <LayoutWrapper>
                    <ControllerMyPayments />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/cati/surveys"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'charge_etude', 'charge_etude_superieur', 'resp_controle', 'chef_terrain', 'chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <CatiSurveys />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/cati/surveys/create"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'charge_etude', 'charge_etude_superieur', 'resp_controle', 'chef_terrain', 'chef_terrain_superieur']}>
                  <LayoutWrapper>
                    <CreateSurvey />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cati/surveys/:id/stats"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'charge_etude', 'charge_etude_superieur', 'resp_controle', 'chef_terrain_superieur', 'chef_terrain', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <SurveyStats />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cati/surveys/:id"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'charge_etude', 'charge_etude_superieur', 'resp_controle', 'chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <SurveyDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cati/productivity"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <CatiProductivity />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/f2f/productivity"
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'charge_etude', 'charge_etude_superieur', 'resp_controle']}>
                  <LayoutWrapper>
                    <F2FProductivity />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/f2f/frais-deplacement"
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <FraisDeplacementList />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/f2f/frais-deplacement/:id"
              element={
                <ProtectedRoute allowedRoles={['chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <FraisDeplacementBuilder />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cati/anomalies"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati']}>
                  <LayoutWrapper>
                    <CatiAnomalies />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/cati/interview-uploads"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'charge_etude', 'charge_etude_superieur', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <InterviewUploads />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/cati/interview-uploads/create"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati']}>
                  <LayoutWrapper>
                    <UploadInterviewFile />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/cati/interview-uploads/survey/:surveyId"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'charge_etude', 'charge_etude_superieur', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <InterviewUploads />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cati/interview-uploads/:uploadId/lines/:lineId"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'charge_etude', 'charge_etude_superieur', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <InterviewLineDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cati/interview-uploads/:id"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'charge_etude', 'charge_etude_superieur', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <InterviewUploadDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/supervisors-cati"
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <SupervisorsCatiList />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/supervisors-cati/create"
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <CreateSupervisorCati />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/supervisors-cati/:id"
              element={
                <ProtectedRoute allowedRoles={['resp_cati']}>
                  <LayoutWrapper>
                    <EditSupervisorCati />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cati/blacklist"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati']}>
                  <LayoutWrapper>
                    <CatiAgencyBlacklist />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            {/* Control Module Routes - Responsable Contrôle */}
            <Route 
              path="/control/surveys" 
              element={
                <ProtectedRoute allowedRoles={['resp_controle']}>
                  <LayoutWrapper>
                    <SurveySelection />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/control/full-control" 
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'chef_terrain_superieur', 'charge_etude', 'charge_etude_superieur']}>
                  <LayoutWrapper>
                    <FullControlSurveys />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/control/full-control/:surveyId/submissions" 
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'chef_terrain_superieur', 'charge_etude', 'charge_etude_superieur']}>
                  <LayoutWrapper>
                    <FullControlSubmissions />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/control/f2f-new-submissions/:digestId"
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <F2fNewSubmissions />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/control/alerts" 
              element={
                <ProtectedRoute allowedRoles={['resp_controle']}>
                  <LayoutWrapper>
                    <AlertsList />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/control/quality-batches" 
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'chef_terrain_superieur', 'charge_etude', 'charge_etude_superieur']}>
                  <LayoutWrapper>
                    <QualityBatchesList />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/control/completed"
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'chef_terrain', 'chef_terrain_superieur', 'charge_etude', 'charge_etude_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <CompletedControls />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/control/stats"
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'chef_terrain', 'chef_terrain_superieur', 'charge_etude', 'charge_etude_superieur', 'administrateur_general', 'administrateur_general_superieur', 'resp_cati', 'supervisor_cati']}>
                  <LayoutWrapper>
                    <ControlStats />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/control/f2f-payment-preview"
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <F2fPaymentPreview />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/control/controller-stats"
              element={
                <ProtectedRoute allowedRoles={['resp_controle', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <ControllerStats />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route 
              path="/cati/productivity/stats"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati', 'chef_terrain_superieur', 'resp_controle', 'charge_etude_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <ProductivityStats />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route
              path="/control/attendance"
              element={
                <ProtectedRoute allowedRoles={['resp_controle']}>
                  <LayoutWrapper>
                    <ControllerAttendance />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cati/attendance"
              element={
                <ProtectedRoute allowedRoles={['resp_cati', 'supervisor_cati']}>
                  <LayoutWrapper>
                    <InterviewerAttendance />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            {/* Control Module Routes - Contrôleur */}
            <Route
              path="/control/workspace"
              element={
                <ProtectedRoute allowedRoles={['controleur']}>
                  <LayoutWrapper>
                    <ControlWorkspace />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/control/search"
              element={
                <ProtectedRoute allowedRoles={['controleur']}>
                  <LayoutWrapper>
                    <ControlOnDemandSearch />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/control/on-hold"
              element={
                <ProtectedRoute allowedRoles={['controleur']}>
                  <LayoutWrapper>
                    <ControlOnHold />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/control/on-hold/:id"
              element={
                <ProtectedRoute allowedRoles={['controleur']}>
                  <LayoutWrapper>
                    <ControlOnHoldDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/control/my-checks"
              element={
                <ProtectedRoute allowedRoles={['controleur']}>
                  <LayoutWrapper>
                    <MyChecks />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            {/* Resp Controle Direct Control Routes */}
            <Route
              path="/resp-controle/workspace"
              element={
                <ProtectedRoute allowedRoles={['resp_controle']}>
                  <LayoutWrapper>
                    <RespControleWorkspace />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/resp-controle/my-checks"
              element={
                <ProtectedRoute allowedRoles={['resp_controle']}>
                  <LayoutWrapper>
                    <RespControleMyChecks />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/resp-controle/on-hold"
              element={
                <ProtectedRoute allowedRoles={['resp_controle']}>
                  <LayoutWrapper>
                    <RespControleOnHold />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/resp-controle/on-hold/:id"
              element={
                <ProtectedRoute allowedRoles={['resp_controle']}>
                  <LayoutWrapper>
                    <RespControleOnHoldDetail />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/resp-controle/ai/upload"
              element={
                <ProtectedRoute allowedRoles={['resp_controle']}>
                  <LayoutWrapper>
                    <RespControleAiUpload />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/resp-controle/ai/checks"
              element={
                <ProtectedRoute allowedRoles={['resp_controle']}>
                  <LayoutWrapper>
                    <RespControleAiChecks />
                  </LayoutWrapper>
                </ProtectedRoute>
              }
            />
            {/* Quota Management Routes */}
            <Route 
              path="/quotas" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <QuotaProjects />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/quotas/create"
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <CreateQuotaProject />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/quotas/:projectId" 
              element={
                <ProtectedRoute allowedRoles={['charge_etude', 'charge_etude_superieur', 'chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur']}>
                  <LayoutWrapper>
                    <QuotaBuilder />
                  </LayoutWrapper>
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
        <Analytics />
      </Router>
    </AuthProvider>
  );
}

export default App;
